import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { useCurrentUser } from '../../../hooks';
import {
  edit_affiliate_settings_path,
  edit_topics_settings_path,
  edit_user_email_settings_path,
  edit_user_privacy_settings_path,
  edit_user_team_settings_path,
  group_subscriptions_settings_path,
  user_dashboard_path,
} from '../../../routes.js';
import styles from './styles.module.scss';

const SETTING_NAV_OPTIONS = [
  { path: user_dashboard_path, label: 'Account', access: false },
  { path: edit_affiliate_settings_path, label: 'Referral', access: false },
  { path: edit_topics_settings_path, label: 'Following', access: false },
  { path: edit_user_email_settings_path, label: 'Email Preferences', access: false },
  { path: group_subscriptions_settings_path, label: 'Gift Subscriptions', access: false },
  { path: edit_user_team_settings_path, label: 'Team Subscriptions', access: false },
  { path: edit_user_privacy_settings_path, label: 'Privacy', access: false },
];

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentActiveItem = SETTING_NAV_OPTIONS.find(
    (option) => option.path() === location.pathname
  );
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const [navSettings, setNavSettings] = useState(SETTING_NAV_OPTIONS);

  const activeItemNav = () => {
    return {
      borderColor: '#d04237',
      color: '#222426',
    };
  };

  useEffect(() => {
    if (!isLoadingCurrentUser) {
      setNavSettings((prevNavSettings) =>
        prevNavSettings.map((option) => {
          switch (option.label) {
            case 'Privacy':
              return { ...option, access: currentUser?.settings_access_obj?.privacy_access };
            default:
              return { ...option, access: true };
          }
        })
      );
    }
  }, [isLoadingCurrentUser, currentUser?.settings_access_obj?.privacy_access]);

  if (isLoadingCurrentUser) {
    return null;
  }

  return (
    <>
      <div className={styles.settingsHeaderContainer}>
        <div className={styles.settingsHeader}>Settings</div>
        <div className={styles.settingNavMobile}>
          <Select
            options={navSettings.filter((option) => option.access)}
            onChange={(e) => navigate(e.path())}
            value={currentActiveItem}
            getOptionValue={(navSettings) => navSettings.label}
            isSearchable={false}
          />
        </div>
      </div>
      <div className={styles.settingsNavContainer}>
        <div>
          {navSettings
            .filter((option) => option.access)
            .map((option) => (
              <NavLink
                key={option.label}
                end
                to={option.path()}
                className={styles.navItem}
                style={(isActive) => (isActive.isActive ? activeItemNav() : undefined)}
              >
                {option.label}
              </NavLink>
            ))}
        </div>
      </div>
    </>
  );
};

export default Layout;
